export { default as en } from './en'
export { default as dk } from './dk'
export { default as de } from './de'
export { default as es } from './es'
export { default as tw } from './tw'
export { default as zh } from './zh'